module.exports = __webpack_public_path__ + "assets/img/DS-master (6).4a211127.jpg";